module.exports = __webpack_public_path__ + "img/volleyball.d3b20312.svg";